import React from 'react';
import ContactForm from '../components/ContactForm';
import ContactInfo from '../components/ContactInfo';
import Header from '../components/common/Header';

export default function Contact() {
  return (
    <div
      className="relative flex size-full min-h-screen flex-col bg-[#fafcf8] justify-between group/design-root overflow-x-hidden"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <div>
        {/* Header */}
        <Header showBackButton={true} backButtonText="Home" />

        {/* Centered Content Container */}
        <div className="max-w-2xl mx-auto px-6">
          {/* Contact Form Section */}
          <ContactForm />

          {/* Contact Information Section */}
          <ContactInfo />
        </div>
      </div>

    </div>
  );
}
